import { Box } from "@mui/material";

const TeamsUsers = () => {
  return (
    <Box sx={{marginLeft:"10px"}}>
      <iframe
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTfhSOpN3Jw23RMChqNiIhxnBCl84lSQy4AekWtf21mr--Z18XWpx8hS_4kmcRM0Q/pubhtml?widget=true&amp;headers=false "
        width="1072"
        height="520"
      ></iframe>
    </Box>
  );
};

export default TeamsUsers;
